import ReactPhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

type IPhoneInputProps = Omit<PhoneInputProps, 'onChange'> & {
  hasError?: boolean;
  label?: string;
  onChange: (value: string) => void;
};

const PhoneInput: React.FC<IPhoneInputProps> = ({
  value,
  onChange,
  hasError = false,
  label,
  disabled = false,
  specialLabel = label ?? 'Enter your phone Number',
  country = 'us',
  onlyCountries = ['us'],
  countryCodeEditable = false,
  inputProps = {},
  ...props
}) => (
  <ReactPhoneInput
    disabled={disabled}
    specialLabel={specialLabel}
    country={country}
    containerClass={`phone-input ${hasError ? 'error' : ''}`}
    value={`+${value?.replaceAll('+', '')}`}
    countryCodeEditable={countryCodeEditable}
    onlyCountries={onlyCountries}
    onChange={(val) => onChange(`+${val?.replaceAll('+', '')}`)}
    prefix="+"
    inputProps={{
      placeholder: '(555) 555-1234',
      ...inputProps,
    }}
    {...props}
  />
);

export default PhoneInput;
